"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31803],{

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ convertToPixel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  gap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap",
        gap: props.gap || "0"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c5bdc04d-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return convertToPixel(width);
}, function(param) {
    var height = param.height;
    return convertToPixel(height);
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, function(param) {
    var gap = param.gap;
    return convertToPixel(gap);
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "EU": function() { return /* binding */ DESKTOP_APP_UPDATER_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "oV": function() { return /* binding */ SENTRY_ENV; },
/* harmony export */   "oj": function() { return /* binding */ SENTRY_DSN; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v2.5";
var API_VERSION_ALT = "v2.4" || 0;
var API_BASE_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.stockbit.com";
var API_TRADING_URL = "https://trading.masonline.id";
var API_TRADING_URL_V2 = "https://carina.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api-sekuritas.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_UPDATER_URL = "https://sda-updater.stockbit.com";
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.stockbit.com.stockbit"));
var SENTRY_DSN = "https://98926e1d329e4da4bf7a3dc35a3f2ee9@sentry.stockbit.io/167";
var SENTRY_ENV = "production";



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "ah": function() { return /* binding */ TRADING_VIEW_ASSET; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "m6": function() { return /* binding */ TRADING_VIEW_ASSET_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var TRADING_VIEW_ASSET_PREFIX = process.env.NEXT_PUBLIC_TV_ASSET || "https://stockbit.com/tradingview/charting_library/";
var TRADING_VIEW_ASSET = "https://storage.stockbit.com/assets/tradingview/" || 0;
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-5DQC6T3" || 0;
var siteUrl = "https://stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "6ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "44ed90bf-ce78-4f5f-a9f8-82e000538b9b" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 99055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["LOGIN_DATA_TYPE_UNSPECIFIED"] = "LOGIN_DATA_TYPE_UNSPECIFIED";
    LoginType["LOGIN_DATA_TYPE_SUCCESS"] = "LOGIN_DATA_TYPE_SUCCESS";
    LoginType["LOGIN_DATA_TYPE_NEW_DEVICE"] = "LOGIN_DATA_TYPE_NEW_DEVICE";
    LoginType["LOGIN_DATA_TYPE_TRUSTED_DEVICE"] = "LOGIN_DATA_TYPE_TRUSTED_DEVICE";
})(LoginType || (LoginType = {}));


/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "Qh": function() { return /* binding */ checkShowTableByType; }
/* harmony export */ });
/* unused harmony exports getErrorMessage, memoizeChild */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56644);



var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return memo(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    if (!newResponse) return null;
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};
var checkShowTableByType = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var showTable = [
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Saham */ .Z.Saham,
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Right */ .Z.Right,
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Waran */ .Z.Waran,
        global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_1__/* .StockType.Etf */ .Z.Etf, 
    ].includes(type.toLowerCase());
    return showTable;
};


/***/ }),

/***/ 85910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ BasicChallenges; },
/* harmony export */   "JC": function() { return /* binding */ OTPChannelTypes; }
/* harmony export */ });
/* unused harmony export ChallengePINStates */
var OTPChannelTypes;
(function(OTPChannelTypes) {
    OTPChannelTypes["EMAIL"] = "CHANNEL_EMAIL";
    OTPChannelTypes["SMS"] = "CHANNEL_SMS";
    OTPChannelTypes["WHATSAPP"] = "CHANNEL_WHATSAPP";
    OTPChannelTypes["UNSPECIFIED"] = "CHANNEL_UNSPECIFIED";
    OTPChannelTypes["PROMPT"] = "CHANNEL_PROMPT";
})(OTPChannelTypes || (OTPChannelTypes = {}));
var BasicChallenges;
(function(BasicChallenges) {
    BasicChallenges["INITIAL"] = "CHALLENGE_INITIAL_OTP";
    BasicChallenges["OTP"] = "CHALLENGE_OTP";
    BasicChallenges["VERIFY_OTP"] = "CHALLENGE_VERIFY_OTP";
    BasicChallenges["FINISHED"] = "CHALLENGE_FINISH";
    BasicChallenges["FACE_MATCHING"] = "CHALLENGE_FACE_MATCHING";
    BasicChallenges["CURRENT_PASSWORD"] = "CHALLENGE_CURRENT_PASSWORD";
    BasicChallenges["REQUEST_NEW_PASSWORD"] = "CHALLENGE_REQUEST_NEW_PASSWORD";
    BasicChallenges["CONFIRM_NEW_PASSWORD"] = "CHALLENGE_CONFIRM_NEW_PASSWORD";
    BasicChallenges["IDENTITY"] = "CHALLENGE_IDENTITY";
    BasicChallenges["REQUEST_NEW_EMAIL"] = "CHALLENGE_REQUEST_NEW_EMAIL";
    BasicChallenges["NEW_EMAIL_OTP"] = "CHALLENGE_NEW_EMAIL_OTP";
    BasicChallenges["REQUEST_NEW_PHONE_NUMBER"] = "CHALLENGE_REQUEST_NEW_PHONE_NUMBER";
    BasicChallenges["NEW_PHONE_NUMBER_OTP"] = "CHALLENGE_NEW_PHONE_NUMBER_OTP";
})(BasicChallenges || (BasicChallenges = {}));
var ChallengePINStates;
(function(ChallengePINStates) {
    ChallengePINStates["INITIAL"] = "CHALLENGE_INITIAL_OTP";
    ChallengePINStates["IDENTITY"] = "PIN_MUTATION_STATE_IDENTITY";
    ChallengePINStates["OTP"] = "PIN_MUTATION_STATE_OTP";
    ChallengePINStates["FACE_MATCHING"] = "PIN_MUTATION_STATE_FACE_MATCHING";
    ChallengePINStates["PIN_CREATION"] = "PIN_MUTATION_STATE_PIN_CREATION";
    ChallengePINStates["PIN_CONFIRMATION"] = "PIN_MUTATION_STATE_PIN_CONFIRMATION";
    ChallengePINStates["COMPLETED"] = "PIN_MUTATION_STATE_COMPLETED";
    ChallengePINStates["CURRENT_PIN"] = "PIN_MUTATION_STATE_CURRENT_PIN";
})(ChallengePINStates || (ChallengePINStates = {}));


/***/ }),

/***/ 807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ useTrustedDeviceStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/features/login/types.ts
var types = __webpack_require__(99055);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/lib/api/trustedDevice.ts


var request = exodus/* default.withLanguageInstance */.Z.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.ENGLISH */.$6.ENGLISH, true);
var requestWithoutAlert = exodus/* default.withLanguageInstance */.Z.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.ENGLISH */.$6.ENGLISH, false);
var requestOtpNewDevice = function(param) {
    var token = param.token, channel = param.channel;
    return request.post("/login/v3/new-device/otp", {
        token: token,
        channel: channel
    });
};
var verifyOtpNewDevice = function(param) {
    var token = param.token, otp = param.otp;
    return requestWithoutAlert.post("/login/v3/new-device/otp/verify", {
        token: token,
        otp: otp
    });
};
var requestVerifyIdentity = function(param) {
    var token = param.token, identity = param.identity, birthDate = param.birthDate, bankAccountNumber = param.bankAccountNumber, motherName = param.motherName;
    return requestWithoutAlert.post("login/v4/recovery/identity/validate", {
        token: token,
        identity: identity,
        birth_date: birthDate,
        bank_account_number: bankAccountNumber,
        mother_name: motherName
    });
};
var requestVerifyPassword = function(param) {
    var token = param.token, password = param.password;
    return request.post("login/v4/recovery/password/validate", {
        token: token,
        password: password
    });
};
var requestVerifyPin = function(param) {
    var token = param.token, pin = param.pin;
    return request.post("login/v4/recovery/pin/validate", {
        token: token,
        pin: pin
    });
};
var requestOtpTrustedDevice = function(param) {
    var token = param.token, channel = param.channel;
    return request.post("login/v4/recovery/otp", {
        token: token,
        channel: channel
    });
};
var verifyOtpTrustedDevice = function(param) {
    var token = param.token, otp = param.otp;
    return requestWithoutAlert.post("login/v4/recovery/otp/verify", {
        token: token,
        otp: otp
    });
};
var requestSendPrompt = function(param) {
    var token = param.token;
    return requestWithoutAlert.post("login/v4/new-device/prompt/send", {
        token: token
    });
};
var getPromptResult = function(token) {
    return requestWithoutAlert.get("mfa/v1/prompt/verified/result", {
        params: {
            token: token
        }
    });
};
var verifyPromptRequest = function(param) {
    var token = param.token, acknowledgeToken = param.acknowledgeToken;
    return requestWithoutAlert.post("login/v4/new-device/prompt/verify", {
        token: token,
        acknowledge_token: acknowledgeToken
    });
};
var requestForgotPin = function(param) {
    var token = param.token;
    return request.post("login/v4/recovery/pin/forgot", {
        token: token
    });
};

// EXTERNAL MODULE: ./src/features/trusted-device/types.ts
var trusted_device_types = __webpack_require__(81945);
// EXTERNAL MODULE: ./src/features/securities/setting/types.ts
var setting_types = __webpack_require__(85910);
;// CONCATENATED MODULE: ./src/features/trusted-device/utils.ts

var mapOtpOptions = function(otpRecipients) {
    return otpRecipients === null || otpRecipients === void 0 ? void 0 : otpRecipients.map(function(o) {
        if (o.channel === setting_types/* OTPChannelTypes.EMAIL */.JC.EMAIL) {
            return {
                value: setting_types/* OTPChannelTypes.EMAIL */.JC.EMAIL,
                icon: "/icon/password-email-small.svg",
                text: "Send via Email",
                subText: o.target
            };
        }
        if (o.channel === setting_types/* OTPChannelTypes.WHATSAPP */.JC.WHATSAPP) {
            return {
                value: setting_types/* OTPChannelTypes.WHATSAPP */.JC.WHATSAPP,
                icon: "/icon/password-whatsapp.svg",
                text: "Send via Whatsapp",
                subText: o.target
            };
        }
        if (o.channel === setting_types/* OTPChannelTypes.SMS */.JC.SMS) {
            return {
                value: setting_types/* OTPChannelTypes.SMS */.JC.SMS,
                icon: "/icon/password-message.svg",
                text: "Send via SMS",
                subText: o.target
            };
        }
        return {
            value: setting_types/* OTPChannelTypes.EMAIL */.JC.EMAIL,
            icon: "/icon/password-email-small.svg",
            text: "Send via Email",
            subText: o.target
        };
    });
};
var calculateRemainingOtpSecond = function(dateTime) {
    if (!dateTime) {
        return 0;
    }
    var givenTime = new Date(dateTime);
    var currentTime = new Date();
    var timeDifference = givenTime.getTime() - currentTime.getTime();
    var remainingSecond = Math.floor(timeDifference / 1000);
    return remainingSecond;
};

// EXTERNAL MODULE: ./src/features/trusted-device/tracker.ts + 1 modules
var tracker = __webpack_require__(33597);
;// CONCATENATED MODULE: ./src/features/trusted-device/store.ts














var initialState = {
    loginType: types/* LoginType.LOGIN_DATA_TYPE_UNSPECIFIED */.B.LOGIN_DATA_TYPE_UNSPECIFIED,
    newDeviceConfig: {
        login_token: "",
        verification_token: ""
    },
    trustedDevice: {
        token: "",
        deviceName: "",
        /// Prompt Section ///
        promptToken: "",
        promptRemainingSecond: 0,
        promptTarget: "",
        promptStatus: trusted_device_types/* PROMPT_STATUS.PROMPT_STATUS_UNSPECIFIED */.g.PROMPT_STATUS_UNSPECIFIED,
        ackPrompToken: "",
        /// ----------- ///
        /// OTP Section ///
        otpRecipients: [],
        channel: setting_types/* OTPChannelTypes.EMAIL */.JC.EMAIL,
        otp: "",
        target: "",
        remainingSecond: 0,
        /// ----------- ///
        /// API Call State ///
        isSubmitting: false,
        errorText: "",
        errors: []
    }
};
var useTrustedDeviceStore = (0,esm/* default */.ZP)()((0,middleware/* persist */.tJ)((0,immer/* immer */.n)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        updateLoginType: function(loginType) {
            return set({
                loginType: loginType
            });
        },
        resetLoginType: function() {
            return set({
                loginType: initialState.loginType
            });
        },
        updatenewDeviceConfig: function(params) {
            return set(function(draft) {
                draft.newDeviceConfig = params;
            });
        },
        resetNewDeviceConfig: function() {
            get().updatenewDeviceConfig(initialState.newDeviceConfig);
        },
        updateTrustedDevice: function(param) {
            var token = param.token, promptToken = param.promptToken, promptRemainingSecond = param.promptRemainingSecond, promptTarget = param.promptTarget, ackPrompToken = param.ackPrompToken, promptStatus = param.promptStatus, channel = param.channel, deviceName = param.deviceName, otpRecipients = param.otpRecipients, otp = param.otp, target = param.target, remainingSecond = param.remainingSecond, isSubmitting = param.isSubmitting, errorText = param.errorText, errors = param.errors;
            return set(function(draft) {
                draft.trustedDevice.token = token !== null && token !== void 0 ? token : draft.trustedDevice.token;
                draft.trustedDevice.promptToken = promptToken !== null && promptToken !== void 0 ? promptToken : draft.trustedDevice.promptToken;
                draft.trustedDevice.promptRemainingSecond = promptRemainingSecond !== null && promptRemainingSecond !== void 0 ? promptRemainingSecond : draft.trustedDevice.promptRemainingSecond;
                draft.trustedDevice.promptTarget = promptTarget !== null && promptTarget !== void 0 ? promptTarget : draft.trustedDevice.promptTarget;
                draft.trustedDevice.ackPrompToken = ackPrompToken !== null && ackPrompToken !== void 0 ? ackPrompToken : draft.trustedDevice.ackPrompToken;
                draft.trustedDevice.promptStatus = promptStatus !== null && promptStatus !== void 0 ? promptStatus : draft.trustedDevice.promptStatus;
                draft.trustedDevice.deviceName = deviceName !== null && deviceName !== void 0 ? deviceName : draft.trustedDevice.deviceName;
                draft.trustedDevice.otpRecipients = otpRecipients !== null && otpRecipients !== void 0 ? otpRecipients : draft.trustedDevice.otpRecipients;
                draft.trustedDevice.channel = channel !== null && channel !== void 0 ? channel : draft.trustedDevice.channel;
                draft.trustedDevice.otp = otp !== null && otp !== void 0 ? otp : draft.trustedDevice.otp;
                draft.trustedDevice.target = target !== null && target !== void 0 ? target : draft.trustedDevice.target;
                draft.trustedDevice.remainingSecond = remainingSecond !== null && remainingSecond !== void 0 ? remainingSecond : draft.trustedDevice.remainingSecond;
                draft.trustedDevice.isSubmitting = isSubmitting !== null && isSubmitting !== void 0 ? isSubmitting : draft.trustedDevice.isSubmitting;
                draft.trustedDevice.errorText = errorText !== null && errorText !== void 0 ? errorText : draft.trustedDevice.errorText;
                draft.trustedDevice.errors = errors !== null && errors !== void 0 ? errors : draft.trustedDevice.errors;
            });
        },
        resetTrustedDevice: function() {
            get().updateTrustedDevice(initialState.trustedDevice);
        },
        requestValidateIdentity: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var ktp, dob, bankAccount, mothersName, cb, ref, ref1, token, response, ref2, ref3;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ktp = param.ktp, dob = param.dob, bankAccount = param.bankAccount, mothersName = param.mothersName, cb = param.cb;
                            _ctx.prev = 1;
                            ;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: "",
                                errors: []
                            });
                            token = get().trustedDevice.token;
                            _ctx.next = 7;
                            return requestVerifyIdentity({
                                token: token,
                                identity: ktp,
                                birthDate: dob,
                                bankAccountNumber: bankAccount,
                                motherName: mothersName
                            });
                        case 7:
                            response = _ctx.sent;
                            get().updateTrustedDevice({
                                token: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.token
                            });
                            cb();
                            _ctx.next = 17;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            (0,tracker/* trackerIdentityVerificationFailed */.ey)();
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.message,
                                errors: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref3 = _ctx.t0.cause) === null || ref3 === void 0 ? void 0 : ref3.errors
                            });
                        case 17:
                            _ctx.prev = 17;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(17);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        12,
                        17,
                        20
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestValidatePassword: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var password, cb, token, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            password = param.password, cb = param.cb;
                            _ctx.prev = 1;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            token = get().trustedDevice.token;
                            _ctx.next = 6;
                            return requestVerifyPassword({
                                token: token,
                                password: password
                            });
                        case 6:
                            (0,tracker/* trackerInputPasswordSuccess */.gV)();
                            cb();
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message
                            });
                        case 14:
                            _ctx.prev = 14;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(14);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        10,
                        14,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestValidatePin: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var pin, cb, ref, ref1, token, response, ref2;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            pin = param.pin, cb = param.cb;
                            _ctx.prev = 1;
                            ;
                            token = get().trustedDevice.token;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _ctx.next = 7;
                            return requestVerifyPin({
                                pin: pin,
                                token: token
                            });
                        case 7:
                            response = _ctx.sent;
                            get().updateTrustedDevice({
                                otpRecipients: mapOtpOptions(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.otp_recipients)
                            });
                            (0,tracker/* trackerInputPinSuccess */.QE)();
                            cb();
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.message
                            });
                        case 17:
                            _ctx.prev = 17;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(17);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13,
                        17,
                        20
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestForgotPIN: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, token, response, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        token = get().trustedDevice.token;
                        get().updateTrustedDevice({
                            isSubmitting: true,
                            errorText: ""
                        });
                        _ctx.next = 6;
                        return requestForgotPin({
                            token: token
                        });
                    case 6:
                        response = _ctx.sent;
                        (0,AlertMessage/* default */.Z)({
                            content: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message,
                            alertType: "snackbar-dark",
                            messageType: "success",
                            hasCloseIcon: false
                        });
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                        });
                    case 14:
                        _ctx.prev = 14;
                        get().updateTrustedDevice({
                            isSubmitting: false
                        });
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    14,
                    17
                ]
            ]);
        })),
        requestOtpTrustedDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, _trustedDevice, token, channel, response, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        get().updateTrustedDevice({
                            isSubmitting: true,
                            errorText: ""
                        });
                        _trustedDevice = get().trustedDevice, token = _trustedDevice.token, channel = _trustedDevice.channel;
                        _ctx.next = 6;
                        return requestOtpTrustedDevice({
                            token: token,
                            channel: channel
                        });
                    case 6:
                        response = _ctx.sent;
                        get().updateTrustedDevice({
                            target: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.target,
                            remainingSecond: calculateRemainingOtpSecond(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.next_attempt_time)
                        });
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.cause) === null || ref4 === void 0 ? void 0 : ref4.message
                        });
                    case 14:
                        _ctx.prev = 14;
                        get().updateTrustedDevice({
                            isSubmitting: false
                        });
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    14,
                    17
                ]
            ]);
        })),
        verifyOtpTrustedDevice: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
                var ref, _trustedDevice, token, otp, response, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _trustedDevice = get().trustedDevice, token = _trustedDevice.token, otp = _trustedDevice.otp;
                            _ctx.next = 6;
                            return verifyOtpTrustedDevice({
                                token: token,
                                otp: otp
                            });
                        case 6:
                            response = _ctx.sent;
                            get().updateLoginType(types/* LoginType.LOGIN_DATA_TYPE_SUCCESS */.B.LOGIN_DATA_TYPE_SUCCESS);
                            (0,tracker/* trackerLoginCompleted */.pO)();
                            cb(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                            });
                        case 16:
                            _ctx.prev = 16;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(16);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12,
                        16,
                        19
                    ]
                ]);
            }));
            return function(cb) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestPromptTrustedDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, token, response, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        get().updateTrustedDevice({
                            isSubmitting: true,
                            errorText: ""
                        });
                        token = get().trustedDevice.token;
                        _ctx.next = 6;
                        return requestSendPrompt({
                            token: token
                        });
                    case 6:
                        response = _ctx.sent;
                        get().updateTrustedDevice({
                            promptToken: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.prompt_token,
                            promptTarget: response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.target,
                            promptRemainingSecond: calculateRemainingOtpSecond(response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.next_attempt_time)
                        });
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref6 = _ctx.t0.cause) === null || ref6 === void 0 ? void 0 : ref6.message
                        });
                        throw _ctx.t0;
                    case 15:
                        _ctx.prev = 15;
                        get().updateTrustedDevice({
                            isSubmitting: false
                        });
                        return _ctx.finish(15);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    15,
                    18
                ]
            ]);
        })),
        getResultPrompTrustedDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, promptToken, response, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        promptToken = get().trustedDevice.promptToken;
                        _ctx.next = 5;
                        return getPromptResult(promptToken);
                    case 5:
                        response = _ctx.sent;
                        get().updateTrustedDevice({
                            ackPrompToken: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.acknowledge_token,
                            promptStatus: response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.status
                        });
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.cause) === null || ref4 === void 0 ? void 0 : ref4.message
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        })),
        verifyPromptTrustedDevice: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
                var ref, _trustedDevice, token, ackPrompToken, response, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _trustedDevice = get().trustedDevice, token = _trustedDevice.token, ackPrompToken = _trustedDevice.ackPrompToken;
                            _ctx.next = 6;
                            return verifyPromptRequest({
                                token: token,
                                acknowledgeToken: ackPrompToken
                            });
                        case 6:
                            response = _ctx.sent;
                            get().updateLoginType(types/* LoginType.LOGIN_DATA_TYPE_SUCCESS */.B.LOGIN_DATA_TYPE_SUCCESS);
                            (0,tracker/* trackerLoginCompleted */.pO)();
                            cb(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                            });
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(cb) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}), {
    name: "trustedDevice"
}));


/***/ }),

/***/ 33597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ey": function() { return /* binding */ trackerIdentityVerificationFailed; },
  "Wj": function() { return /* binding */ trackerIdentityVerificationStarted; },
  "gV": function() { return /* binding */ trackerInputPasswordSuccess; },
  "QE": function() { return /* binding */ trackerInputPinSuccess; },
  "SU": function() { return /* binding */ trackerLoginAttempt; },
  "pO": function() { return /* binding */ trackerLoginCompleted; },
  "Z3": function() { return /* binding */ trackerPromptSent; }
});

// UNUSED EXPORTS: trackerOtpVerified

// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
;// CONCATENATED MODULE: ./src/features/trusted-device/constants.ts
var constants_EVENT_NAME = {
    NEW_DEVICE_LOGIN_ATTEMPT: "New Device Login Attempt",
    PROMPT_SENT_TO_TRUSTED_DEVICE: "Prompt Sent To Trusted Device",
    FALLBACK_IDENTITY_VERIFICATION_STARTED: "Fallback Identity Verification Started",
    MANUAL_VERIFICATION_FAILED: "Manual Verification Failed",
    NEW_DEVICE_LOGIN_INPUT_PASSWORD_SUCCESS: "New Device Login Input Password Success",
    NEW_DEVICE_LOGIN_INPUT_PIN_SUCCESS: "New Device Login Input Pin Success",
    NEW_DEVICE_LOGIN_OTP_VERIFIED: "New Device Login Otp Verified",
    NEW_DEVICE_LOGIN_COMPLETED: "New Device Login Completed"
};

;// CONCATENATED MODULE: ./src/features/trusted-device/tracker.ts


var trackerLoginAttempt = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.NEW_DEVICE_LOGIN_ATTEMPT);
};
var trackerPromptSent = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.PROMPT_SENT_TO_TRUSTED_DEVICE);
};
var trackerIdentityVerificationStarted = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.FALLBACK_IDENTITY_VERIFICATION_STARTED);
};
var trackerIdentityVerificationFailed = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.MANUAL_VERIFICATION_FAILED);
};
var trackerInputPasswordSuccess = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.NEW_DEVICE_LOGIN_INPUT_PASSWORD_SUCCESS);
};
var trackerInputPinSuccess = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.NEW_DEVICE_LOGIN_INPUT_PIN_SUCCESS);
};
var trackerOtpVerified = function() {
    return clevertapEvent(EVENT_NAME.NEW_DEVICE_LOGIN_OTP_VERIFIED);
};
var trackerLoginCompleted = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(constants_EVENT_NAME.NEW_DEVICE_LOGIN_COMPLETED);
};


/***/ }),

/***/ 81945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ PROMPT_STATUS; }
/* harmony export */ });
var PROMPT_STATUS;
(function(PROMPT_STATUS) {
    PROMPT_STATUS["PROMPT_STATUS_UNSPECIFIED"] = "PROMPT_STATUS_UNSPECIFIED";
    PROMPT_STATUS["PROMPT_STATUS_PENDING"] = "PROMPT_STATUS_PENDING";
    PROMPT_STATUS["PROMPT_STATUS_APPROVED"] = "PROMPT_STATUS_APPROVED";
    PROMPT_STATUS["PROMPT_STATUS_REJECTED"] = "PROMPT_STATUS_REJECTED";
    PROMPT_STATUS["PROMPT_STATUS_EXPIRED"] = "PROMPT_STATUS_EXPIRED";
})(PROMPT_STATUS || (PROMPT_STATUS = {}));


/***/ }),

/***/ 6430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12461);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);





var alertIcon = {
    success: "alert-success.svg",
    warning: "alert-warning.svg",
    info: "alert-info.svg",
    error: "alert-error.svg"
};
function alertMessage(param) {
    var content = param.content, messageType = param.messageType, alertType = param.alertType, _hasCloseIcon = param.hasCloseIcon, hasCloseIcon = _hasCloseIcon === void 0 ? false : _hasCloseIcon, _duration = param.duration, duration = _duration === void 0 ? 3 : _duration, _onCloseHandler = param.onCloseHandler, onCloseHandler = _onCloseHandler === void 0 ? function() {} : _onCloseHandler;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
    var Icon = null;
    if (alertType === "snackbar" || alertType === "snackbar-dark") {
        Icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/icon/".concat(alertIcon[messageType])
        });
    }
    var closeIcon = hasCloseIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "notif-close-icon",
        src: "/icon/alert-close.svg",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        }
    }) : null;
    antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].open */ .ZP.open({
        type: messageType,
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "message-".concat(messageType, " alert-").concat(alertType),
            "data-cy": "global-alert-message",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    Icon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: typeof content === "string" ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(content) : ""
                    }),
                    closeIcon
                ]
            })
        }),
        duration: duration,
        style: {
            top: "50px",
            fontFamily: "ProximaNovaRg",
            left: 0,
            margin: "auto",
            position: "fixed",
            right: 0
        },
        icon: null,
        className: "sysmsg-alert",
        onClick: function() {
            return antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].destroy */ .ZP.destroy();
        },
        onClose: onCloseHandler
    });
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (alertMessage);


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 56644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StockType; }
/* harmony export */ });
var StockType;
(function(StockType) {
    StockType["Saham"] = "saham";
    StockType["Right"] = "right";
    StockType["Waran"] = "waran";
    StockType["Index"] = "index";
    StockType["IndexAsing"] = "index_asing";
    StockType["Reksadana"] = "reksadana";
    StockType["Commodities"] = "commodities";
    StockType["Crypto"] = "crypto";
    StockType["Fx"] = "fx";
    StockType["Etf"] = "etf";
    StockType["Bond"] = "bond";
    StockType["FR"] = "fr";
})(StockType || (StockType = {}));


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ AcceptanceLanguageEnum; },
/* harmony export */   "RD": function() { return /* binding */ SubAccountType; },
/* harmony export */   "el": function() { return /* binding */ TnCFeaturesIDEnum; },
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; },
/* harmony export */   "hO": function() { return /* binding */ TnCFeatureIDEnum; },
/* harmony export */   "rO": function() { return /* binding */ TnCFeaturePersistMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var AcceptanceLanguageEnum;
(function(AcceptanceLanguageEnum) {
    AcceptanceLanguageEnum["BAHASA"] = "ID";
    AcceptanceLanguageEnum["ENGLISH"] = "EN";
})(AcceptanceLanguageEnum || (AcceptanceLanguageEnum = {}));
var TnCFeatureIDEnum;
(function(TnCFeatureIDEnum) {
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_UNSPECIFIED"] = 0] = "FEATURE_UNSPECIFIED";
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_TRADING_LIMIT"] = 1] = "FEATURE_TRADING_LIMIT";
})(TnCFeatureIDEnum || (TnCFeatureIDEnum = {}));
var SubAccountType;
(function(SubAccountType) {
    SubAccountType["DAY_TRADE"] = "SUB_ACCOUNT_TYPE_DAY_TRADE";
})(SubAccountType || (SubAccountType = {}));
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["ACTIVE"] = "SUB_ACCOUNT_STATUS_ACTIVE";
})(SubAccountStatus || (SubAccountStatus = {}));
var TnCFeaturesIDEnum;
(function(TnCFeaturesIDEnum) {
    TnCFeaturesIDEnum["TRADING_LIMIT"] = "FEATURE_ID_TRADING_LIMIT";
    TnCFeaturesIDEnum["AUTO_ORDER"] = "FEATURE_ID_AUTO_ORDER";
    TnCFeaturesIDEnum["DAY_TRADE"] = "FEATURE_ID_DAY_TRADE";
    TnCFeaturesIDEnum["MULTI_PORTO"] = "FEATURE_ID_MULTIPLE_PORTFOLIO";
})(TnCFeaturesIDEnum || (TnCFeaturesIDEnum = {}));
var _obj;
var TnCFeaturePersistMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.TRADING_LIMIT, "tradingLimitTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.AUTO_ORDER, "autoOrderTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.DAY_TRADE, "dayTradeTnc"), _obj);


/***/ }),

/***/ 78372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    noAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    customUserAgent: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false, null, true),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (exodusInstance);


/***/ }),

/***/ 76260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: 0,
    errorMessage: "",
    errorType: ""
};
var tradingStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingStore);


/***/ }),

/***/ 19225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth; }
});

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./src/constants/cookies.js
var ACCESS_TOKEN_KEY = "access_token";
var ACCESS_TOKEN_KEY_EXP = "access_token_exp";
var REFRESH_TOKEN_KEY = "refresh_token";
var REFRESH_TOKEN_KEY_EXP = "refresh_token_exp";
var ACCESS_USER_KEY = "access_user";
/*  securities/trading related cookies */ var TRADING_ACCESS_TOKEN = "securities_access_token";
var TRADING_REFRESH_TOKEN = "securities_refresh_token";
var TRADE_IS_LOGGED_IN = "trade_is_logged_in";
var TRADING_ACCOUNT_TYPE = "trading_account_type";
var LAST_TRADING_ACCOUNT_TYPE = "last_trading_account_type";
var TRADING_BROKER = "stockbit";
var PLAYER_ID = "player-id";


// EXTERNAL MODULE: ./src/constants/localstorage.js
var localstorage = __webpack_require__(44252);
// EXTERNAL MODULE: ./src/features/orderbook/utils.ts
var utils = __webpack_require__(51346);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/utils/auth.js







function getToken() {
    if (!(0,app/* isClient */.C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[localstorage/* ACCESS_TOKEN_KEY */.Wx] ? (0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* ACCESS_TOKEN_KEY */.Wx]) : null;
    var accessTokenExp = ls[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0] ? parseInt((0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0]), 10) : null;
    var refreshToken = ls[localstorage/* REFRESH_TOKEN_KEY */.w4] ? (0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* REFRESH_TOKEN_KEY */.w4]) : null;
    var refreshTokenExp = ls[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv] ? parseInt((0,general/* decodeBase64ToJS */.OB)(ls[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,isAfter/* default */.Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,isAfter/* default */.Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,app/* isClient */.C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[localstorage/* ACCESS_USER_KEY */.ns] = (0,general/* encodeBase64FromJS */.me)(accessUser);
    }
    localStorage[localstorage/* ACCESS_TOKEN_KEY */.Wx] = (0,general/* encodeBase64FromJS */.me)(accessToken);
    localStorage[localstorage/* ACCESS_TOKEN_KEY_EXP */.z0] = (0,general/* encodeBase64FromJS */.me)(accessTokenExp.toString());
    localStorage[localstorage/* REFRESH_TOKEN_KEY */.w4] = (0,general/* encodeBase64FromJS */.me)(refreshToken);
    localStorage[localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv] = (0,general/* encodeBase64FromJS */.me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,app/* isClient */.C5)()) {
        localStorage[localstorage/* ACCESS_USER_KEY */.ns] = (0,general/* encodeBase64FromJS */.me)(accessUser);
    }
}
function destroyToken() {
    if ((0,app/* isClient */.C5)()) {
        localStorage.removeItem(localstorage/* ACCESS_USER_KEY */.ns);
        localStorage.removeItem(localstorage/* ACCESS_TOKEN_KEY */.Wx);
        localStorage.removeItem(localstorage/* ACCESS_TOKEN_KEY_EXP */.z0);
        localStorage.removeItem(localstorage/* REFRESH_TOKEN_KEY */.w4);
        localStorage.removeItem(localstorage/* REFRESH_TOKEN_KEY_EXP */.Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        utils/* localStorageOrderbookHandler.remove */.Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,app/* isClient */.C5)() && localStorage && localStorage[localstorage/* ACCESS_USER_KEY */.ns] ? (0,general/* decodeBase64ToJS */.OB)(localStorage[localstorage/* ACCESS_USER_KEY */.ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,general/* encodeBase64FromJS */.me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,general/* encodeBase64FromJS */.me)(intercom);
};
var isLoggedIn = function() {
    return (0,app/* isClient */.C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
var getPlayerId = function(req) {
    var playerId = (req === null || req === void 0 ? void 0 : req.cookies[PLAYER_ID]) || (0,v4/* default */.Z)();
    return playerId;
};
/* harmony default export */ var auth = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings,
    getPlayerId: getPlayerId
});


/***/ }),

/***/ 48028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ clevertapProfilingUser; },
/* harmony export */   "Lq": function() { return /* binding */ clevertapEvent; },
/* harmony export */   "QU": function() { return /* binding */ clevertapInitProfileQueue; },
/* harmony export */   "Vg": function() { return /* binding */ clearClevertapState; },
/* harmony export */   "nh": function() { return /* binding */ academyUserProfiling; },
/* harmony export */   "ze": function() { return /* binding */ academyEventAnalytic; }
/* harmony export */ });
/* unused harmony export clevertapProfilingUserEligible */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* eslint-disable no-underscore-dangle */ 


var clevertapProfileQueue = [];
function clevertapInitProfileQueue() {
    clevertapProfileQueue.forEach(function(instance) {
        return instance();
    });
    clevertapProfileQueue = [];
}
/**
 * this function will executes clevertap analytic based on isInitProfile
 * @param {boolean} isInitProfile
 * @param {string} username
 * @param {boolean} isVirtualTrading
 * @param {boolean} isTopUser
 * @param {boolean} isVerifiedUser
 * @param {boolean} isStockbitPro
 * @param {Date} registrationStartDate
 * @param {string} profilePictureUrl
 * @param {boolean} isSinarmasSecuritas
 * @param {string} email
 * @param {isStockbitSecuritas} isStockbitSecuritas
 * @return {void} no return after execute this function
 */ function clevertapProfilingUser(param) {
    var isInitProfile = param.isInitProfile, identity = param.identity, isVirtualTrading = param.isVirtualTrading, isTopUser = param.isTopUser, isVerifiedUser = param.isVerifiedUser, isStockbitPro = param.isStockbitPro, registrationStartDate = param.registrationStartDate, profilePictureUrl = param.profilePictureUrl, isSinarmasSecuritas = param.isSinarmasSecuritas, email = param.email, isStockbitSecuritas = param.isStockbitSecuritas, _isEmitenUser = param.isEmitenUser, isEmitenUser = _isEmitenUser === void 0 ? false : _isEmitenUser;
    // Track if username is empty
    if (!identity) {
        (0,_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
            place: "src/utils/clevertap.ts",
            event: "clevertapProfilingUser",
            eventParam: {
                profile: {
                    identity: identity,
                    email: email
                }
            }
        });
    }
    var clevertapProfilingData = {
        Name: identity,
        Identity: identity,
        "Is Virtual Trading": isVirtualTrading !== undefined ? isVirtualTrading : undefined,
        "Is Top User": isTopUser !== undefined ? isTopUser : undefined,
        "Is Verified User": isVerifiedUser !== undefined ? isVerifiedUser : undefined,
        "Is Stockbit Pro": isStockbitPro !== undefined ? isStockbitPro : undefined,
        "Registration Start Date": registrationStartDate !== undefined ? registrationStartDate : undefined,
        Photo: profilePictureUrl !== undefined ? "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(profilePictureUrl) : undefined,
        "Is Sinarmas Sekuritas": isSinarmasSecuritas !== undefined ? isSinarmasSecuritas : undefined,
        Email: email !== undefined ? email : undefined,
        "Is Stockbit Sekuritas": isStockbitSecuritas !== undefined ? isStockbitSecuritas : undefined,
        "Is Emiten User": isEmitenUser !== undefined ? isEmitenUser : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingData).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingData[key] !== undefined) {
            _acc[key] = clevertapProfilingData[key];
        }
        return _acc;
    }, {});
    var handleInitProfile = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.onUserLogin.push({
            Site: payload
        });
    };
    var handleProfilePush = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
            Site: payload
        });
    };
    var initProfileFunction = isInitProfile ? handleInitProfile : handleProfilePush;
    if (!window.clevertap) {
        clevertapProfileQueue.push(initProfileFunction);
        return;
    }
    initProfileFunction();
}
function clevertapEvent(eventName) {
    var eventObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Object.keys(eventObject).length > 0) {
        var // execute this impression if impression has additional attributes
        ref, ref1;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.push(eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventObject));
    } else {
        var ref2, ref3;
        (ref2 = window.clevertap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.push(eventName);
    }
}
function clevertapProfilingUserEligible(param) {
    var followers = param.followers, following = param.following, posts = param.posts, isMuted = param.isMuted, isVerifiedEligible = param.isVerifiedEligible;
    var clevertapProfilingDataEligible = {
        Followers: followers !== undefined ? followers : undefined,
        Following: following !== undefined ? following : undefined,
        Posts: posts !== undefined ? posts : undefined,
        "is Muted": isMuted !== undefined ? isMuted : undefined,
        "Is Verified Badge Eligible": isVerifiedEligible !== undefined ? isVerifiedEligible : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingDataEligible).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingDataEligible[key] !== undefined) {
            _acc[key] = clevertapProfilingDataEligible[key];
        }
        return _acc;
    }, {});
    window.clevertap.profile.push({
        Site: payload
    });
}
function academyEventAnalytic(eventName, parameter) {
    if (!eventName) {
        return;
    }
    clevertapEvent(eventName, parameter);
}
function academyUserProfiling() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var ref;
    if (!data && !data.parameter) {
        return;
    }
    // filter to remove undefined value of object
    // eslint-disable-next-line array-callback-return
    var payload = Object.keys(data.parameter).reduce(function(acc, key) {
        var currentAcc = acc;
        if (data[key] !== undefined) {
            currentAcc[key] = data[key];
            return currentAcc;
        }
        return null;
    }, {});
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
        Site: payload
    });
}
function clearClevertapState() {
    var ref, ref1;
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.logout();
    (ref1 = window.clevertap) === null || ref1 === void 0 ? void 0 : ref1.clear();
}


/***/ })

}]);